import React from 'react'
import { StyledIcon } from '../styled'
import { ReactComponent as Icon } from '../assets/min/facebook.svg'

const Facebook = ({ medium, large }) => (
	<StyledIcon medium={medium} large={large}>
		<Icon />
	</StyledIcon>
)

export default Facebook
